import type { FetcherAxiosInstance } from '../fetcher';

export const createSettingsApi = (Fetcher: FetcherAxiosInstance) => ({
  getSettings({ props }: Record<string, any>) {
    return Fetcher('/settings', { params: { props } });
  },
});
